import { Component, trigger, state, style, transition, animate } from '@angular/core';
import { ViewController } from 'ionic-angular';
import { SessionService } from './../../../../../services/session';
import { MapService } from './../../../../../services/map';
import { LocationsService } from '../../../../../services/locations';
import {BeautyClassesService} from '../../../../../services/beauty-classes';
import {BeautyFiltersService} from '../../../../../services/beauty-filters';

@Component({
  selector: 'page-beauty-filters',
  templateUrl: 'beauty-filters.html',
  animations: [
    trigger('list', [
      state(
        'in',
        style({
          opacity: 1,
        })
      ),
      transition('void => *', [
        style({
          opacity: 0,
          transform: 'translateY(-10px)',
        }),
        animate(300),
      ]),
      transition('* => void', [
        animate(
          300,
          style({
            opacity: 0,
            transform: 'translateY(10px)',
          })
        ),
      ]),
    ]),
  ],
})
export class BeautyFiltersPage {
  openCity = false;
  openActivities = false;

  queryParams = {
    from_date: '',
    to_date: '',
    latitude: '',
    longitude: '',
    radius: '',
    touched: false,
    structure: { lower: 5, upper: 23 },
    services: [],
    city: this.sessionService.user.city_id,
    zones: [],
    categories: [],
    gym: [],
  };

  beautyCities = [];

  zones = [];

  ionViewDidLoad() {
    this.zones = this.getZones(this.queryParams.city);
  }

  getZones(zoneId) {
    const city = this.mapService.cities.find(function (element) {
      return element.id === zoneId;
    });

    if (city == null) {
      return [];
    }

    return city.zones;
  }

  locationBy = 'distance';

  constructor(
    private viewCtrl: ViewController,
    public mapService: MapService,
    public sessionService: SessionService,
    public classesService: BeautyClassesService,
    public filtersService: BeautyFiltersService,
    public locationsService: LocationsService
  ) {
    this.queryParams = this.filtersService.queryParams;
    if (this.queryParams.categories && this.queryParams.categories.length === 0) {
      this.unselectAll();
    }

    this.beautyCities = this.mapService.cities.filter(city => city.has_beauty);
  }

  public selectAll(): void {
    for (let i = 0; i < this.classesService.categories.length; i++) {
      this.queryParams.categories[i] = i + 1;
    }
  }

  public touch(): void {
    this.queryParams.touched = true;
  }

  public setCity(city): void {
    this.queryParams.city = city.id;
    this.zones = city.zones;
  }

  //name must be changed to addZone
  public setZone(zone): void {
    var index = this.queryParams.zones ? this.queryParams.zones.indexOf(zone.id) : -1;
    if (index >= 0) {
      this.queryParams.zones.splice(index, 1);
    } else this.queryParams.zones.push(zone.id);
    this.queryParams.radius = '0';
  }

  public setDistance(distance): void {
    this.queryParams.zones = [];
    this.queryParams.radius = distance;
  }

  public dismissModal(): void {
    this.viewCtrl.dismiss();
  }

  public addActivity(category): void {
    var index = this.queryParams.categories ? this.queryParams.categories.indexOf(category) : -1;
    if (index >= 0) {
      this.queryParams.categories.splice(index, 1);
    } else this.queryParams.categories.push(category);
  }

  public unselectAll(): void {
    this.queryParams.categories = [];
  }

  public applyFilters(): void {
    console.log('=> Beauty Filters Service: query params', this.queryParams);
    this.filtersService.queryParams = this.queryParams;
    this.viewCtrl.dismiss(true);
  }

  public favorite(): void {
    this.queryParams.gym = this.queryParams.gym.length > 0 ? [] : this.sessionService.user.favorite_gyms;
  }

  public resetFilters(): void {
    this.queryParams = {
      from_date: '',
      to_date: '',
      latitude: '',
      longitude: '',
      radius: '',
      structure: { lower: 5, upper: 23 },
      touched: false,
      services: [],
      city: this.sessionService.user.city_id,
      zones: [],
      categories: [],
      gym: [],
    };
    for (var i = 0; i < this.classesService.categories.length; i++) {
      this.queryParams.categories[i] = i + 1;
    }
    this.openActivities = false;
    this.locationBy = 'distance';
    this.applyFilters();
  }

  public onServiceSelected(event): void {
    this.queryParams.services = event;
  }

  // '5' will check on the new gyms
  readonly trending = 5;
  readonly notTrending = 6;
  selectedTrendingQuery: 'trending' | 'noTrending' | 'both';
  public selectTrendingQuery(q: 'trending' | 'noTrending' | 'both'): void {
    this.selectedTrendingQuery = q;
    if (q === 'trending') {
      this.changeTrendingQueryTo(this.trending);
    } else if (q === 'noTrending') {
      this.changeTrendingQueryTo(this.notTrending);
    } else {
      if (this.selectedTrendingQueryIndex(this.trending) > -1) {
        this.queryParams.services.splice(this.selectedTrendingQueryIndex(this.trending), 1);
      }
      if (this.selectedTrendingQueryIndex(this.notTrending) > -1) {
        this.queryParams.services.splice(this.selectedTrendingQueryIndex(this.notTrending), 1);
      }
    }
  }

  private changeTrendingQueryTo(index: number): void {
    const notIndex = index === this.trending ? this.notTrending : this.trending;
    if (this.selectedTrendingQueryIndex(index) > -1) {
      return;
    } else if (this.selectedTrendingQueryIndex(notIndex) > -1) {
      this.queryParams.services[this.selectedTrendingQueryIndex(notIndex)] = index;
    } else {
      this.queryParams.services.push(index);
    }
  }

  public selectedTrendingQueryIndex(trendingQuery: number): number {
    if (!this.queryParams.services) {
      return -1;
    }
    return this.queryParams.services.indexOf(trendingQuery);
  }
}



// WEBPACK FOOTER //
// ./src/pages/tabs/beauty/find-beauty-class/beauty-filters/beauty-filters.ts